import React from "react";

const RelevanceIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M4.25 2V14M4.25 14L1.25 11M4.25 14L7.25 11M11.75 14V2M11.75 2L8.75 5M11.75 2L14.75 5" stroke="#242424" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default RelevanceIcon;